import {createContext, useContext, useReducer} from "react";
import detectionReducer from "./detection_reducer";
import {INIT} from "../../../pages/detection/detection_page";

export const DetectionContext = createContext()

export default function DetectionProvider({children}) {
    const detectionState = {
        file: null,
        src: null,
        frameNo: null,
        isReal: false,
        path: null,
        status: INIT,
        result: null,
    }
    const [state, dispatch] = useReducer(detectionReducer, detectionState);

    return (
        <DetectionContext.Provider value={{state, dispatch}}>
            {children}
        </DetectionContext.Provider>
    )
}

export const useDetectionState = () => useContext(DetectionContext)